import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import axios from 'axios';
import { getOpenId, shareAppMessage, isWeChatPc } from "../js/lib/utils";


//处理路由重复访问
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 路由切换，简单的让页面滚动到顶部
    return { x: 0, y: 0 }
  }
});
const filterRouter = [];

// const getUserInfo = (temp) => {
//     return new Promise((resolve, reject) => {
//         let config = {
//             headers:{
//                 'Content-Type': 'application/json',
//             }
//         };  //添加请求头
//         axios.post(`${window.config.ApiBaseURL}${API.getLoginInfo}`, {
//             'token': token
//         }, config)
//         .then(async(res) => {
//             resolve(true);
//         })
//         .catch(e => {
//             reject(e);
//         });
//     })
// }
// router.beforeEach(async (to, from, next) => {
//   let token = localStorage.getItem('token');
//   /*
//   let userToken = localStorage.getItem('userToken');
//   if(!userToken) {//未登录
//       let tokenCookie = document.cookie;
//       if(tokenCookie) {//有cookie
//           let temp = tokenCookie.replace('renogy-pc-token=', '')
//           localStorage.setItem('userToken', temp);
//           let userInfo = await getUserInfo(temp);
//       }
//   }else {//已登录

//   }
//   */
//   // let a = await aa();
//   if (to.meta.requiresAuth) {
//     //页面需要登录
//     if (!token) {
//       next({
//         path: '/login'
//       })
//     } else {
//       if (token && (to.fullPath === '/login' || to.fullPath === '/register')) {
//         //访问登录页面，如果带token则跳转首页
//         next({ path: '/home' });
//       } else {
//         next();
//       }
//     }
//   } else {

//     if (token && (to.fullPath == '/login' || to.fullPath == '/register')) {
//       next({
//         path: '/home'
//       });
//     } else {
//       next();
//     }
//   }
//   // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//   //   navigator.userAgent
//   // );
//   // if (isMobile) {
//   //   window.location.href =
//   //     "https://www.renogy.com/super-solar-calculator.renogy-dchome.com/?from=icon_end";
//   // } else {
//   next();
//   // }
// });
export default router



// WEBPACK FOOTER //
// ./src/router/index.js